import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  /**
   * 필터데이터
   */
  filterData: {},
  isFilterLoading: true,
  /**
   * 계약별 사용률 목록
   */
  agreementUtilizationList: {
    totalCount: 0,
    list: []
  },
  isAgreementUtilizationListLoading: true,

  /**
   * 계약별 사용률 상세
   */
  agreementUtilizationDetail: {
    agreementDetail: {

    },
    transition: []
  },
  isAgreementUtilizationDetailLoading: true,

  /**
   * 인스턴스 패밀리별 사용률 목록
   */
  instanceFamilyUtilizationList: {
    totalCount: 0,
    list: []
  },
  isInstanceFamilyUtilizationListLoading: true,

  /**
   * 서비스별 사용률
   */
  serviceUtilizationList: {
    totalCount: 0,
    list: []
  },
  isServiceUtilizationListLoading: true,

  /**
   * 전체요약 정보
   */
  totalSummary: {
    netSavingsUtil: null,
    usePaymentUtil: null,
    utilization: null,
    totalPayment: null,
    usePayment: null,
    netSavings: null,
    ondemandSpend: null
  },
  isTotalSummaryLoading: true,

  /**
   * 트렌트 차트
   */
  transition: [],
  isTransitionLoading: true,
  selectedViewByOption: ''
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/utilization/index.js